import { Select } from '../../atoms';

type ContactTierOption = {
  value: string;
  label: string;
  disabled?: boolean;
};

export type ContactsTierSelectProps = {
  contactTiersLabel: string;
  contactTiersOptions: ContactTierOption[];
  selectedContactTier: ContactTierOption['value'];
  onContactsTierSelect: (selectedContactTier: ContactTierOption['value']) => void;
  disabled: boolean;
};

export const ContactsTierSelect = ({
  contactTiersOptions,
  selectedContactTier,
  onContactsTierSelect,
  contactTiersLabel,
  disabled,
}: ContactsTierSelectProps) => (
  <div className="payflow-ui contacts-tier-select-container">
    <Select
      className="tier-select"
      fullWidth
      disabled={disabled}
      name="tier-select"
      label={contactTiersLabel}
      options={contactTiersOptions}
      value={selectedContactTier}
      onValueChange={onContactsTierSelect}
    />
  </div>
);
